import React from 'react';

import { FlexView, Col } from '@cuemath/comps';
import styled from 'styled-components';
import COLORS from 'constants/colors';

const OptionsContainer = styled(FlexView)`
  background-color: ${COLORS.WHITE};
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  padding: 5px 0;
  background-clip: padding-box;
  width: 160px;
  position: absolute;
  right: 30px;
  z-index: 6;
`;

const OptionsButton = styled.div`
  font-size: 16px;
  padding: 3px 10px;

  :hover {
    border-radius: 4px;
    background-color: ${COLORS.SKY_DARK};
    color: ${COLORS.WHITE};
  }
`;

const defaultCriteria = {
  attribute: '',
  operator: '',
  attributeValue: '',
  selected: false,
};

const OptionsView = ({
  openBlockModal,
  openDependencyModal,
  openEditChapterModal = null,
  onDeleteNode,
  nodeId,
  node,
  timedSheet,
  openEditReportConfig,
}) => {
  if (openEditChapterModal !== null) {
    const chapterData = {
      node: node[nodeId],
      isChapter: node[nodeId].isChapter,
      activityNodeData: node[nodeId].activityNodeData,
      onDelete: node[nodeId].deleteNode,
      isSelected: node[nodeId].selected,
      numProps: Object.values(node[nodeId].getPorts()).length - 1,
      completionData: node[nodeId].completionData,
      reattemptData: node[nodeId].reattemptData,
    };

    return (
      <OptionsContainer>
        <Col gutter={4} weight="semibold">
          <OptionsButton onClick={() => openBlockModal(nodeId)}>
            Change Block
          </OptionsButton>
          <OptionsButton onClick={() => openDependencyModal(nodeId, [[defaultCriteria]])}>
            Unlock Criteria
          </OptionsButton>
          {timedSheet && (
            <OptionsButton
              onClick={() => openEditReportConfig(node[nodeId].activityNodeData)}
            >
              Edit Report Config
            </OptionsButton>
          )}
          {openEditChapterModal && (
            <OptionsButton onClick={() => openEditChapterModal({ ...chapterData })}>
              Edit Node
            </OptionsButton>
          )}
          <OptionsButton onClick={() => onDeleteNode(nodeId)}>Delete Node</OptionsButton>
        </Col>
      </OptionsContainer>
    );
  } else {
    return (
      <OptionsContainer>
        <Col gutter={4} weight="semibold">
          <OptionsButton onClick={() => onDeleteNode(nodeId)}>Delete Node</OptionsButton>
        </Col>
      </OptionsContainer>
    );
  }
};

export default OptionsView;
